/* eslint-disable no-unused-vars */
import 'babel-polyfill';
import "@/components";
import "@/variants/whb/components";
import "@/directives";
import "@/filters";
import Vue from 'vue';
import '@/mixins';
import App from '@/App.vue';
import store from '@/store';
import './menu';
import http from "@/http";
Vue.prototype.$http = http;
import router from './router';
import { vuetify } from '@/plugins';
import colors from 'vuetify/lib/util/colors';
Vue.prototype.$dialogs = {};
import axios from 'axios';


import config from '@/config';
import variantConfig from './config';
Vue.prototype.$config = { ...config, ...variantConfig };

import { useFavicon, useTitle } from '@vueuse/core';
const icon = useFavicon();
icon.value = 'data:image/x-icon;base64,AAABAAEAEBAAAAEAIABoBAAAFgAAACgAAAAQAAAAIAAAAAEAIAAAAAAAAAQAABILAAASCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADV1dYA1tbXFKWkpVm3t7hS3NzcF////wb9/f0A////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3t7eAOTk5CSmpqeteXl65nJycsmXl5iQtbW1NeLi4wYAAAAA////AAAAAAAAAAAA////Aefm+B3Bv+xCiofbQmpl0EOQjt012NjfGKWlpVdeXl+4NTU29ENCROBmZWeQlpaWNe7u7gV2dnYA////AK2q5G9rZtDDU07I8kM8w/I6NMD1gH7WwOvr+hIAAAAAmpqbEUhHSIAfHh/1HRwe/T4+P+CCgoKPxMTFHqysrQBRS8f3JyG6/ycgu/8oILv/Lie8/5eU3rb///8P9PT8AJuamwC0tLUVW1pbuhgXGf8WFRf/KCcp/F9fYKepqKoiQTvC/ycguv8tJrz/KSK7/z43wfybmOBmAACjAP7+/wD+/v4AAAAAAIaFh2ctLC78FxYY/xcWGP8iISL7cG9wvIJ/170wKr37KCG7/yoju/85MsD8iYbaZgAAqwD+/v8AgH+CAHt6fACGhYdbMTAx+xcWGP8ZGBr/FhUX/y0sLv/IyO4idXPTqDo1wPwnIbr/KCG7/2tm0Mzc2/QyvbvqAOLi4gD///8Ga2prihsaHP4VFBb/FRQX/xgXGf9EQ0T3x8btAOHg9R6cmuCQVVDJ4C4nvf0wKr3/ambQoNXU8i4CAG4A4ODhEXt7fL8xMTL1NjU380lJSvJjYmTDo6OjcP///wDOzPAA////Brq46TWDf9eQV1LJ30NAw/lubNDOpKLhV9PS6heVlpY1cHByQ4KBgkK5ublC5OTkHv///wEAAAAAAAAAAP///wBgXsoA+fn9BtDO8DSHhdljdXPRsnp31M+0sues7u78I+jo+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///8A////AtPQ8Qq1suc0wsHrWeDf9RTf3/UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//8AAP//AAD4PwAA+A8AAAADAAABAQAAAYAAAAPAAAADwAAAAYAAAICAAADAAAAA8B8AAPwfAAD//wAA//8AAA==';
const title = useTitle();
title.value = 'Beléptető - WHB';

vuetify.framework.theme.themes['dark'] = {
  primary: '#eb3337',
  secondary: '#1c2442',
  accent: '#eb3337',
  // white: colors.grey.darken4,
  // grey: colors.grey.darken3,
  muted: '#333',
  background: '#282828',
  success: colors.green.base,
  error: colors.red.base,
  warning: colors.amber.darken1,
  text: colors.white,
};
vuetify.framework.theme.themes['light'] = {
  primary: '#e92226',
  secondary: '#1c2442',
  accent: '#e92226',
  // white: colors.white.base,
  // grey: colors.grey.base,
  muted: '#f1f1f1',
  background: '#eee',
  success: colors.green.base,
  error: colors.red.base,
  warning: colors.amber.darken1,
  text: colors.black,
};

Vue.config.productionTip = false;
// Vue.config.silent = true;

Vue.prototype.$logout = async ({ message, redirect }) => {
  await window.vue.$http.get('auth/logout');
  window.vue.$router.push({ name: 'Login', params: { message, redirect: redirect || window.vue.$route.fullPath } });
};



window.vue = new Vue({
  data: {
    version: '2021.01.24.22.50',
    user: {},
    pageMsg: {
      type: '',
      text: ''
    },
    socket: ''
  },
  methods: {
    checkRootUserHasSet(cb) {
      cb();
    },
    smallButtonMenu() {
      Vue.nextTick(() => {
        $(document).on('click', '.small-button.with-menu', function(e) {
          e.preventDefault();
          $('.small-button-menu').not($(this).next('.small-button-menu')).removeClass('open');
          $(this).next('.small-button-menu').toggleClass('open');
        });

        $(document).on('click', function(e) {
          if (!$(e.target).hasClass('customicon') && !$(e.target).hasClass('small-button')) {
            $('.small-button-menu').removeClass('open');
          }
        });
      });
    },

    generateGUID: function() {
        function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },
    ajax: function(url, user_options) {
      var _this = this;

      // Verzió ellenőrzés
      $.ajax({
        url: process.env.VUE_APP_API_URL + 'getVersion/' + _this.version,
        dataType: 'json',
        success: function(response) {
          if (response.status == 'ERROR') {
            swal('Figyelem', response.msg, 'error');
            return;
          } else {
            _this.callajax(url, user_options);
          }
        }
      });
    },
    callajax: function(url, user_options) {
      var _this = this;

      var options = {
        method: 'GET',
        dataType: 'json',
        data: {},
        async: true,
        success: function() {},
        error: function() {},
        waitForSaveInfo: false
      };

      options = $.extend({}, options, user_options);

      try {
        if (url == undefined)
          throw 'Url hiányzik';

        $.ajax({
          method: options.method,
          url: process.env.VUE_APP_API_URL + url,
          async: options.async,
          data: options.data,
          //cache: false,
          timeout: 1800000,
          dataType: options.dataType,
          error: options.error,
          beforeSend: options.beforeSend ? options.beforeSend : ()=>{},
          success: function (response) {
            if (response.status == 'OK') {
              setTimeout(function() {
                options.success(response);
              }, options.waitForSaveInfo ? 500 : 0);

            } else if (response.status == 'NO_ACCESS') {
              const params = {
                type: 'error',
                text: 'Nincs joga a művelethez'
              };
              _this.$router.push({ name: 'Message', params });

            } else if (response.status == 'NO_LOGGED_USER') {
              const params = {
                type: 'error',
                text: 'Nem található bejelentkezett felhasználó.'
              };
              _this.$router.push({ name: 'Message', params });

            } else if (response.status == 'NO_API_KEY') {
              const params = {
                type: 'error',
                text: 'Nem található API kulcs'
              };
              _this.$router.push({ name: 'Message', params });

            } else if (response.status == 'NO_VALID_API_KEY') {
              const params = {
                type: 'error',
                text: 'Érvénytelen az API kulcs'
              };
              _this.$router.push({ name: 'Message', params });

            } else if (response.status == 'ERROR') {
              const params = {
                type: 'error',
                text: response.msg
              };
              _this.$router.push({ name: 'Message', params });

            } else if (response.status == 'DATABASE_ERROR') {
              const params = {
                type: 'error',
                text: response.text
              };
              _this.$router.push({ name: 'Message', params });
            }
          }
        });

      } catch(error) {
        alert(error);
      }
    }
  },
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
